var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.onlinestate=="pc"?"":"look_id",attrs:{"id":"app"}},[_c('div',{class:_vm.islang=="eng"&&_vm.onlinestate !=="pc"?"look_en":""},[_c('router-view'),_vm._v(" "),(_vm.$store.state.island)?_c('div',{staticStyle:{"width":"100vw","height":"100vh","background-color":"#fff","z-index":"2000"}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-fe6479ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 